/// <amd-module name="TFS/Admin/Views/ProfileSettings/RefreshPermissionsView/RefreshPermissionsView" />
import React = require("react");

import * as Resources from "TFS/Admin/Views/ProfileSettings/RefreshPermissionsView/Resources";
import { IVssComponentContext, VssComponent, Components } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";
import { Button } from "VSSUI/Button";
import { Header, TitleSize, HeaderDescription } from "VSSUI/Header";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";
import { IVssPageService, IPageData } from "VSS/Platform/Page";
import { getIdentitiesClient, IIdentitiesRestClient } from "TFS/Admin/Common/RestClient/Identities";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { AdminTelemetry, AdminFeatureTelemetryLogger } from "TFS/Admin/Common/Util/Telemetry/AdminTelemetry";
import { Feature } from "TFS/Admin/Common/Constants/TelemetryConstants";

interface IProfileRefreshPermissionsState {
    isRefreshInProgress: boolean;
}

export default class RefreshPermissionsComponent extends VssComponent<{}, IProfileRefreshPermissionsState> {

    private _telemetryLogger: AdminTelemetry = new AdminTelemetry(this.context.pageContext);

    private pageContext: IVssPageContext;
    private currentUserId: string;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this.pageContext = context.pageContext;
        this.currentUserId = "";
        const pageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();

        if (pageData && pageData.user) {
            this.currentUserId =  pageData.user.id;
        }

        this.state = {
            isRefreshInProgress: false
        }
    }

    public render() {
        return (
            <div>
                <Surface background={SurfaceBackground.neutral}>
                    <Page className="flex-grow rhythm-vertical-16">
                        <Header title={Resources.Title} titleSize={TitleSize.Large} />
                        <div className="page-content page-content-top">
                            <div>
                                <Button
                                    text={Resources.RefreshButton}
                                    onClick={this._onRefreshPermissions}
                                    disabled={this.state.isRefreshInProgress}
                                >
                                </Button>
                            </div>
                            <p>{Resources.RefreshButtonDescription}</p>
                        </div>
                    </Page>
                </Surface>
                {this.state.isRefreshInProgress ? (
                    <div className="refresh-permissions-overlay flex-column flex-center justify-center">
                        <Spinner
                            size={SpinnerSize.large}
                            label={Resources.DownloadSpinnerMessage}
                        />
                    </div>
                ) : null}
            </div>
        );
    }

    private _onRefreshPermissions = async (): Promise<void> => { 
        this.setState({
            isRefreshInProgress: true
        });
        
        const telemetryLogger = this._startActionCapture("Refresh Permissions", {
            "UserIdFromPageService" : this.currentUserId
        });
        const messagesService: IGlobalMessagesService = await this.context.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");

        try {
            if (this.currentUserId === "") {
                throw "Could not resolve user id from page data";
            }

            const identityClient: IIdentitiesRestClient = await getIdentitiesClient(this.pageContext);
            await identityClient.refreshMembersOf(this.currentUserId);

            messagesService.addToast({
                message: Resources.RefreshSuccessful,
                duration: 3000,
                forceOverrideExisting: true
            });
        } catch (error) {
            telemetryLogger.captureError(error)

            messagesService.addToast({
                message: Resources.RefreshFailed,
                duration: 3000,
                forceOverrideExisting: true
            });

            throw error;
        } finally {
            this.setState({
                isRefreshInProgress: false
            });
        }
    };

    private _startActionCapture(action: string, properties: { [key: string]: any } = {}): AdminFeatureTelemetryLogger {
        return this._telemetryLogger.startActionCapture(Feature.ProfileRefreshPermissions, Feature.ProfileRefreshPermissions, action, properties);
    }
}

Components.add("RefreshPermissionsView", RefreshPermissionsComponent);